import Image from "next/image";

import { PostCover } from "./types";
import * as S from "./styles";

const Cover = (props: PostCover) => {
  return (
    <S.Cover>
      <Image src={`${props.cover}`} title={props.title}  alt={props.description} layout="fill" />
    </S.Cover>
  );
};

export default Cover;
